const isIEBrowser = () => {
  const ua = window.navigator.userAgent
  const msie = ua.indexOf('MSIE ')

  return msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)
}

export default isIEBrowser
